import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    alignItems: 'center',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    overflow: 'hidden',

    '& svg': {
      marginRight: 8,
      marginBottom: '-2px',
      marginLeft: 12
    },

    '& label': {
      cursor: 'pointer'
    }
  },

  articleRoot: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: 8
  },

  tooltipContainer: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 8,
    marginLeft: 9
  },

  noMarginRight: {
    marginRight: 0
  },

  tagContainer: {
    marginLeft: 10,
    color: '#8F8F8F',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginTop: '10px',
    fontSize: theme.size.sm,
    display: 'flex'
  },

  remainingTag: {
    marginLeft: 6
  }
}))

export default useStyles
